























import { Component, Vue } from 'vue-property-decorator';
import LogoUnion from '@/components/merchant/LogoUnion.vue';
import { copyText } from '@/utils/common';

@Component({
  name: 'RegisterSuccess',
  components: {
    LogoUnion
  }
})

export default class RegisterSuccess extends Vue {
  created() {
    document.title = '注册成功';
  }

  copyMpCode() {
    // 复制支口令
    copyText('3# wa:/EwC2Xh399mw#@此消息，👍支宝👈搜索，体验俏租机小程序');
  }
}
